




import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IMksTemplateExecutable,
  instanceOfIMksTemplateExecutable,
} from "../../../../domain/document/items";
import {
  ExternalTemplateExecuteResult,
} from "../../../../domain/localhost/items";
import { Dictionary } from "../../../../domain/system";
import { EditingDocument } from "..";
import { CommonDialogsAccessor } from "../CommonComponentsAccessor";

@Component
export default class MksTemplateAdapter extends Mixins() {
  @Prop()
  source: EditingDocument;

  @Prop()
  dialogs: CommonDialogsAccessor;

  isInputable(source: IMksTemplateExecutable): boolean {
    return instanceOfIMksTemplateExecutable(source)
        && source.mksTemplateFormats
        && (0 < source.mksTemplateFormats.length);
  }

  async input(source: IMksTemplateExecutable): Promise<ExternalTemplateExecuteResult> {
    if (!this.isInputable(source)) {
      throw new Error("invalid item");
    }
    const parameters = await this.toParameters(source);
    if (!parameters) {
      this.$logger.info("MKSテンプレート選択処理がキャンセルされました。");
      return null;
    }
    const result = await this.dialogs.application.launcher.show(null, parameters, null);
    if (!result || !result.isComplete) {
      throw new Error("MKSテンプレートが正常に完了しませんでした。");
    }
    if (!result.registeredId) {
      // 出力ファイルが存在していない場合（MKSテンプレート画面でキャンセルなど）
      return null;
    }
    return result;
  }

  private async toParameters(source: IMksTemplateExecutable): Promise<Dictionary<string, string>> {
    return !source.mksTemplateRegisteredId
      ? this.toNewParameters(source)    // まだ未実行.
      : this.toEditParameters(source);  // 既に実行済.
  }

  private async toNewParameters(source: IMksTemplateExecutable): Promise<Dictionary<string, string>> {
    const selectedTemplateCode = await this.selectTemplate(source.mksTemplateFormats.map(t => t.value));
    if (!selectedTemplateCode) {
      return null;
    }
    const parameters = this.createParameters(source);
    parameters.set("mksCode", selectedTemplateCode);
    return parameters;
  }

  private async toEditParameters(source: IMksTemplateExecutable): Promise<Dictionary<string, string>> {
    const parameters = this.createParameters(source);
    parameters.set("mksId", source.mksTemplateRegisteredId);
    return parameters;
  }

  private createParameters(source: IMksTemplateExecutable): Dictionary<string, string> {
    const dictionary = new Dictionary<string, string>();
    dictionary.set("action", "mksTemplate");
    dictionary.set("patientId", this.source.source.attributes.patient.id);
    return dictionary;
  }

  async selectTemplate(templateCodes: string[]): Promise<string> {
    // 設定されているテンプレートが一つのときは選択画面を表示しない
    return (templateCodes.length === 1)
      ? templateCodes[0]
      : this.dialogs.mksTemplate.templateSelector.show(templateCodes);
  }
}
